import React from 'react';
import ProjectDetailView from 'components/ProjectDetailView/ProjectDetailView';
import renesData from './data';

const Renes = () => {
  return <ProjectDetailView data={renesData} />;
};

export default Renes;
